/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as dashboardDashboardRouteImport } from './routes/(dashboard)/_dashboard'
import { Route as authAuthRouteImport } from './routes/(auth)/_auth'
import { Route as dashboardDashboardSalarySlipRouteImport } from './routes/(dashboard)/_dashboard/salary-slip'
import { Route as dashboardDashboardReimbursementRouteImport } from './routes/(dashboard)/_dashboard/reimbursement'
import { Route as dashboardDashboardEmployeeTrainingRouteImport } from './routes/(dashboard)/_dashboard/employee-training'
import { Route as dashboardDashboardAttendanceMapRouteImport } from './routes/(dashboard)/_dashboard/attendance-map'
import { Route as dashboardDashboardAttendanceRouteImport } from './routes/(dashboard)/_dashboard/attendance'
import { Route as authAuthLoginRouteImport } from './routes/(auth)/_auth/login'
import { Route as dashboardDashboardProfileIndexRouteImport } from './routes/(dashboard)/_dashboard/profile/index'
import { Route as dashboardDashboardPerformanceReviewIndexRouteImport } from './routes/(dashboard)/_dashboard/performance-review/index'
import { Route as dashboardDashboardLoanIndexRouteImport } from './routes/(dashboard)/_dashboard/loan/index'
import { Route as dashboardDashboardAttendanceIndexRouteImport } from './routes/(dashboard)/_dashboard/attendance/index'
import { Route as dashboardDashboardProfileIdRouteImport } from './routes/(dashboard)/_dashboard/profile/$id'
import { Route as dashboardDashboardPerformanceReviewIdRouteImport } from './routes/(dashboard)/_dashboard/performance-review/$id'
import { Route as dashboardDashboardMasterDataOfficeRouteImport } from './routes/(dashboard)/_dashboard/master-data/office'
import { Route as dashboardDashboardMasterDataEmployeeAddRouteImport } from './routes/(dashboard)/_dashboard/master-data/employee-add'
import { Route as dashboardDashboardLoanIdRouteImport } from './routes/(dashboard)/_dashboard/loan/$id'
import { Route as dashboardDashboardHrUnitRouteImport } from './routes/(dashboard)/_dashboard/hr/unit'
import { Route as dashboardDashboardHrPositionRouteImport } from './routes/(dashboard)/_dashboard/hr/position'
import { Route as dashboardDashboardHrEmployeeRouteImport } from './routes/(dashboard)/_dashboard/hr/employee'
import { Route as dashboardDashboardHrDivisionRouteImport } from './routes/(dashboard)/_dashboard/hr/division'
import { Route as dashboardDashboardFinancePayrollComponentRouteImport } from './routes/(dashboard)/_dashboard/finance/payroll-component'
import { Route as dashboardDashboardEssOvertimeRouteImport } from './routes/(dashboard)/_dashboard/ess/overtime'
import { Route as dashboardDashboardAttendanceWaitingApprovalRouteImport } from './routes/(dashboard)/_dashboard/attendance/waiting-approval'
import { Route as dashboardDashboardAttendanceMonthlyReportRouteImport } from './routes/(dashboard)/_dashboard/attendance/monthly-report'
import { Route as dashboardDashboardApprovalTrainingRouteImport } from './routes/(dashboard)/_dashboard/approval/training'
import { Route as dashboardDashboardApprovalShiftRouteImport } from './routes/(dashboard)/_dashboard/approval/shift'
import { Route as dashboardDashboardApprovalLeaveTypeRouteImport } from './routes/(dashboard)/_dashboard/approval/leave-type'
import { Route as dashboardDashboardApprovalAbsenceTypeRouteImport } from './routes/(dashboard)/_dashboard/approval/absence-type'
import { Route as dashboardDashboardPerformanceReviewIdIndexRouteImport } from './routes/(dashboard)/_dashboard/performance-review/$id/index'
import { Route as dashboardDashboardHrRoleIndexRouteImport } from './routes/(dashboard)/_dashboard/hr/role/index'
import { Route as dashboardDashboardHrEmployeeIndexRouteImport } from './routes/(dashboard)/_dashboard/hr/employee/index'
import { Route as dashboardDashboardFinanceReimbursementIndexRouteImport } from './routes/(dashboard)/_dashboard/finance/reimbursement/index'
import { Route as dashboardDashboardEssLeaveIndexRouteImport } from './routes/(dashboard)/_dashboard/ess/leave/index'
import { Route as dashboardDashboardEssAbsenceIndexRouteImport } from './routes/(dashboard)/_dashboard/ess/absence/index'
import { Route as dashboardDashboardPerformanceReviewIdSummaryRouteImport } from './routes/(dashboard)/_dashboard/performance-review/$id/summary'
import { Route as dashboardDashboardPerformanceReviewIdDocumentStatusRouteImport } from './routes/(dashboard)/_dashboard/performance-review/$id/document-status'
import { Route as dashboardDashboardPerformanceReviewIdCompetencyRouteImport } from './routes/(dashboard)/_dashboard/performance-review/$id/competency'
import { Route as dashboardDashboardHrRoleAddRouteImport } from './routes/(dashboard)/_dashboard/hr/role/add'
import { Route as dashboardDashboardHrEmployeeShiftDailyRouteImport } from './routes/(dashboard)/_dashboard/hr/employee/shift-daily'
import { Route as dashboardDashboardHrEmployeeShiftRouteImport } from './routes/(dashboard)/_dashboard/hr/employee/shift'
import { Route as dashboardDashboardHrEmployeeOfficeRouteImport } from './routes/(dashboard)/_dashboard/hr/employee/office'
import { Route as dashboardDashboardHrEmployeeEditIdRouteImport } from './routes/(dashboard)/_dashboard/hr/employee-edit/$id'
import { Route as dashboardDashboardFinanceReimbursementIdRouteImport } from './routes/(dashboard)/_dashboard/finance/reimbursement/$id'
import { Route as dashboardDashboardEssLeaveIdRouteImport } from './routes/(dashboard)/_dashboard/ess/leave/$id'
import { Route as dashboardDashboardEssAbsenceIdRouteImport } from './routes/(dashboard)/_dashboard/ess/absence/$id'
import { Route as dashboardDashboardFinanceReimbursementIdIndexRouteImport } from './routes/(dashboard)/_dashboard/finance/reimbursement/$id/index'
import { Route as dashboardDashboardHrRoleEditIdRouteImport } from './routes/(dashboard)/_dashboard/hr/role/edit/$id'
import { Route as dashboardDashboardFinanceReimbursementIdEmployeeRouteImport } from './routes/(dashboard)/_dashboard/finance/reimbursement/$id/employee'

const dashboardRouteImport = createFileRoute('/(dashboard)')()
const authRouteImport = createFileRoute('/(auth)')()

const dashboardRoute = dashboardRouteImport.update({
  id: '/(dashboard)',
  getParentRoute: () => rootRouteImport,
} as any)
const authRoute = authRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardDashboardRoute = dashboardDashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => dashboardRoute,
} as any)
const authAuthRoute = authAuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => authRoute,
} as any)
const dashboardDashboardSalarySlipRoute =
  dashboardDashboardSalarySlipRouteImport.update({
    id: '/salary-slip',
    path: '/salary-slip',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardReimbursementRoute =
  dashboardDashboardReimbursementRouteImport.update({
    id: '/reimbursement',
    path: '/reimbursement',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardEmployeeTrainingRoute =
  dashboardDashboardEmployeeTrainingRouteImport.update({
    id: '/employee-training',
    path: '/employee-training',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardAttendanceMapRoute =
  dashboardDashboardAttendanceMapRouteImport.update({
    id: '/attendance-map',
    path: '/attendance-map',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardAttendanceRoute =
  dashboardDashboardAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const authAuthLoginRoute = authAuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authAuthRoute,
} as any)
const dashboardDashboardProfileIndexRoute =
  dashboardDashboardProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardPerformanceReviewIndexRoute =
  dashboardDashboardPerformanceReviewIndexRouteImport.update({
    id: '/performance-review/',
    path: '/performance-review/',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardLoanIndexRoute =
  dashboardDashboardLoanIndexRouteImport.update({
    id: '/loan/',
    path: '/loan/',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardAttendanceIndexRoute =
  dashboardDashboardAttendanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardAttendanceRoute,
  } as any)
const dashboardDashboardProfileIdRoute =
  dashboardDashboardProfileIdRouteImport.update({
    id: '/profile/$id',
    path: '/profile/$id',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardPerformanceReviewIdRoute =
  dashboardDashboardPerformanceReviewIdRouteImport.update({
    id: '/performance-review/$id',
    path: '/performance-review/$id',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardMasterDataOfficeRoute =
  dashboardDashboardMasterDataOfficeRouteImport.update({
    id: '/master-data/office',
    path: '/master-data/office',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardMasterDataEmployeeAddRoute =
  dashboardDashboardMasterDataEmployeeAddRouteImport.update({
    id: '/master-data/employee-add',
    path: '/master-data/employee-add',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardLoanIdRoute =
  dashboardDashboardLoanIdRouteImport.update({
    id: '/loan/$id',
    path: '/loan/$id',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardHrUnitRoute =
  dashboardDashboardHrUnitRouteImport.update({
    id: '/hr/unit',
    path: '/hr/unit',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardHrPositionRoute =
  dashboardDashboardHrPositionRouteImport.update({
    id: '/hr/position',
    path: '/hr/position',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardHrEmployeeRoute =
  dashboardDashboardHrEmployeeRouteImport.update({
    id: '/hr/employee',
    path: '/hr/employee',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardHrDivisionRoute =
  dashboardDashboardHrDivisionRouteImport.update({
    id: '/hr/division',
    path: '/hr/division',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardFinancePayrollComponentRoute =
  dashboardDashboardFinancePayrollComponentRouteImport.update({
    id: '/finance/payroll-component',
    path: '/finance/payroll-component',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardEssOvertimeRoute =
  dashboardDashboardEssOvertimeRouteImport.update({
    id: '/ess/overtime',
    path: '/ess/overtime',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardAttendanceWaitingApprovalRoute =
  dashboardDashboardAttendanceWaitingApprovalRouteImport.update({
    id: '/waiting-approval',
    path: '/waiting-approval',
    getParentRoute: () => dashboardDashboardAttendanceRoute,
  } as any)
const dashboardDashboardAttendanceMonthlyReportRoute =
  dashboardDashboardAttendanceMonthlyReportRouteImport.update({
    id: '/monthly-report',
    path: '/monthly-report',
    getParentRoute: () => dashboardDashboardAttendanceRoute,
  } as any)
const dashboardDashboardApprovalTrainingRoute =
  dashboardDashboardApprovalTrainingRouteImport.update({
    id: '/approval/training',
    path: '/approval/training',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardApprovalShiftRoute =
  dashboardDashboardApprovalShiftRouteImport.update({
    id: '/approval/shift',
    path: '/approval/shift',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardApprovalLeaveTypeRoute =
  dashboardDashboardApprovalLeaveTypeRouteImport.update({
    id: '/approval/leave-type',
    path: '/approval/leave-type',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardApprovalAbsenceTypeRoute =
  dashboardDashboardApprovalAbsenceTypeRouteImport.update({
    id: '/approval/absence-type',
    path: '/approval/absence-type',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardPerformanceReviewIdIndexRoute =
  dashboardDashboardPerformanceReviewIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardPerformanceReviewIdRoute,
  } as any)
const dashboardDashboardHrRoleIndexRoute =
  dashboardDashboardHrRoleIndexRouteImport.update({
    id: '/hr/role/',
    path: '/hr/role/',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardHrEmployeeIndexRoute =
  dashboardDashboardHrEmployeeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardHrEmployeeRoute,
  } as any)
const dashboardDashboardFinanceReimbursementIndexRoute =
  dashboardDashboardFinanceReimbursementIndexRouteImport.update({
    id: '/finance/reimbursement/',
    path: '/finance/reimbursement/',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardEssLeaveIndexRoute =
  dashboardDashboardEssLeaveIndexRouteImport.update({
    id: '/ess/leave/',
    path: '/ess/leave/',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardEssAbsenceIndexRoute =
  dashboardDashboardEssAbsenceIndexRouteImport.update({
    id: '/ess/absence/',
    path: '/ess/absence/',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardPerformanceReviewIdSummaryRoute =
  dashboardDashboardPerformanceReviewIdSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => dashboardDashboardPerformanceReviewIdRoute,
  } as any)
const dashboardDashboardPerformanceReviewIdDocumentStatusRoute =
  dashboardDashboardPerformanceReviewIdDocumentStatusRouteImport.update({
    id: '/document-status',
    path: '/document-status',
    getParentRoute: () => dashboardDashboardPerformanceReviewIdRoute,
  } as any)
const dashboardDashboardPerformanceReviewIdCompetencyRoute =
  dashboardDashboardPerformanceReviewIdCompetencyRouteImport.update({
    id: '/competency',
    path: '/competency',
    getParentRoute: () => dashboardDashboardPerformanceReviewIdRoute,
  } as any)
const dashboardDashboardHrRoleAddRoute =
  dashboardDashboardHrRoleAddRouteImport.update({
    id: '/hr/role/add',
    path: '/hr/role/add',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardHrEmployeeShiftDailyRoute =
  dashboardDashboardHrEmployeeShiftDailyRouteImport.update({
    id: '/shift-daily',
    path: '/shift-daily',
    getParentRoute: () => dashboardDashboardHrEmployeeRoute,
  } as any)
const dashboardDashboardHrEmployeeShiftRoute =
  dashboardDashboardHrEmployeeShiftRouteImport.update({
    id: '/shift',
    path: '/shift',
    getParentRoute: () => dashboardDashboardHrEmployeeRoute,
  } as any)
const dashboardDashboardHrEmployeeOfficeRoute =
  dashboardDashboardHrEmployeeOfficeRouteImport.update({
    id: '/office',
    path: '/office',
    getParentRoute: () => dashboardDashboardHrEmployeeRoute,
  } as any)
const dashboardDashboardHrEmployeeEditIdRoute =
  dashboardDashboardHrEmployeeEditIdRouteImport.update({
    id: '/hr/employee-edit/$id',
    path: '/hr/employee-edit/$id',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardFinanceReimbursementIdRoute =
  dashboardDashboardFinanceReimbursementIdRouteImport.update({
    id: '/finance/reimbursement/$id',
    path: '/finance/reimbursement/$id',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardEssLeaveIdRoute =
  dashboardDashboardEssLeaveIdRouteImport.update({
    id: '/ess/leave/$id',
    path: '/ess/leave/$id',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardEssAbsenceIdRoute =
  dashboardDashboardEssAbsenceIdRouteImport.update({
    id: '/ess/absence/$id',
    path: '/ess/absence/$id',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardFinanceReimbursementIdIndexRoute =
  dashboardDashboardFinanceReimbursementIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardFinanceReimbursementIdRoute,
  } as any)
const dashboardDashboardHrRoleEditIdRoute =
  dashboardDashboardHrRoleEditIdRouteImport.update({
    id: '/hr/role/edit/$id',
    path: '/hr/role/edit/$id',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const dashboardDashboardFinanceReimbursementIdEmployeeRoute =
  dashboardDashboardFinanceReimbursementIdEmployeeRouteImport.update({
    id: '/employee',
    path: '/employee',
    getParentRoute: () => dashboardDashboardFinanceReimbursementIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof dashboardDashboardRouteWithChildren
  '/login': typeof authAuthLoginRoute
  '/attendance': typeof dashboardDashboardAttendanceRouteWithChildren
  '/attendance-map': typeof dashboardDashboardAttendanceMapRoute
  '/employee-training': typeof dashboardDashboardEmployeeTrainingRoute
  '/reimbursement': typeof dashboardDashboardReimbursementRoute
  '/salary-slip': typeof dashboardDashboardSalarySlipRoute
  '/approval/absence-type': typeof dashboardDashboardApprovalAbsenceTypeRoute
  '/approval/leave-type': typeof dashboardDashboardApprovalLeaveTypeRoute
  '/approval/shift': typeof dashboardDashboardApprovalShiftRoute
  '/approval/training': typeof dashboardDashboardApprovalTrainingRoute
  '/attendance/monthly-report': typeof dashboardDashboardAttendanceMonthlyReportRoute
  '/attendance/waiting-approval': typeof dashboardDashboardAttendanceWaitingApprovalRoute
  '/ess/overtime': typeof dashboardDashboardEssOvertimeRoute
  '/finance/payroll-component': typeof dashboardDashboardFinancePayrollComponentRoute
  '/hr/division': typeof dashboardDashboardHrDivisionRoute
  '/hr/employee': typeof dashboardDashboardHrEmployeeRouteWithChildren
  '/hr/position': typeof dashboardDashboardHrPositionRoute
  '/hr/unit': typeof dashboardDashboardHrUnitRoute
  '/loan/$id': typeof dashboardDashboardLoanIdRoute
  '/master-data/employee-add': typeof dashboardDashboardMasterDataEmployeeAddRoute
  '/master-data/office': typeof dashboardDashboardMasterDataOfficeRoute
  '/performance-review/$id': typeof dashboardDashboardPerformanceReviewIdRouteWithChildren
  '/profile/$id': typeof dashboardDashboardProfileIdRoute
  '/attendance/': typeof dashboardDashboardAttendanceIndexRoute
  '/loan': typeof dashboardDashboardLoanIndexRoute
  '/performance-review': typeof dashboardDashboardPerformanceReviewIndexRoute
  '/profile': typeof dashboardDashboardProfileIndexRoute
  '/ess/absence/$id': typeof dashboardDashboardEssAbsenceIdRoute
  '/ess/leave/$id': typeof dashboardDashboardEssLeaveIdRoute
  '/finance/reimbursement/$id': typeof dashboardDashboardFinanceReimbursementIdRouteWithChildren
  '/hr/employee-edit/$id': typeof dashboardDashboardHrEmployeeEditIdRoute
  '/hr/employee/office': typeof dashboardDashboardHrEmployeeOfficeRoute
  '/hr/employee/shift': typeof dashboardDashboardHrEmployeeShiftRoute
  '/hr/employee/shift-daily': typeof dashboardDashboardHrEmployeeShiftDailyRoute
  '/hr/role/add': typeof dashboardDashboardHrRoleAddRoute
  '/performance-review/$id/competency': typeof dashboardDashboardPerformanceReviewIdCompetencyRoute
  '/performance-review/$id/document-status': typeof dashboardDashboardPerformanceReviewIdDocumentStatusRoute
  '/performance-review/$id/summary': typeof dashboardDashboardPerformanceReviewIdSummaryRoute
  '/ess/absence': typeof dashboardDashboardEssAbsenceIndexRoute
  '/ess/leave': typeof dashboardDashboardEssLeaveIndexRoute
  '/finance/reimbursement': typeof dashboardDashboardFinanceReimbursementIndexRoute
  '/hr/employee/': typeof dashboardDashboardHrEmployeeIndexRoute
  '/hr/role': typeof dashboardDashboardHrRoleIndexRoute
  '/performance-review/$id/': typeof dashboardDashboardPerformanceReviewIdIndexRoute
  '/finance/reimbursement/$id/employee': typeof dashboardDashboardFinanceReimbursementIdEmployeeRoute
  '/hr/role/edit/$id': typeof dashboardDashboardHrRoleEditIdRoute
  '/finance/reimbursement/$id/': typeof dashboardDashboardFinanceReimbursementIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof dashboardDashboardRouteWithChildren
  '/login': typeof authAuthLoginRoute
  '/attendance-map': typeof dashboardDashboardAttendanceMapRoute
  '/employee-training': typeof dashboardDashboardEmployeeTrainingRoute
  '/reimbursement': typeof dashboardDashboardReimbursementRoute
  '/salary-slip': typeof dashboardDashboardSalarySlipRoute
  '/approval/absence-type': typeof dashboardDashboardApprovalAbsenceTypeRoute
  '/approval/leave-type': typeof dashboardDashboardApprovalLeaveTypeRoute
  '/approval/shift': typeof dashboardDashboardApprovalShiftRoute
  '/approval/training': typeof dashboardDashboardApprovalTrainingRoute
  '/attendance/monthly-report': typeof dashboardDashboardAttendanceMonthlyReportRoute
  '/attendance/waiting-approval': typeof dashboardDashboardAttendanceWaitingApprovalRoute
  '/ess/overtime': typeof dashboardDashboardEssOvertimeRoute
  '/finance/payroll-component': typeof dashboardDashboardFinancePayrollComponentRoute
  '/hr/division': typeof dashboardDashboardHrDivisionRoute
  '/hr/position': typeof dashboardDashboardHrPositionRoute
  '/hr/unit': typeof dashboardDashboardHrUnitRoute
  '/loan/$id': typeof dashboardDashboardLoanIdRoute
  '/master-data/employee-add': typeof dashboardDashboardMasterDataEmployeeAddRoute
  '/master-data/office': typeof dashboardDashboardMasterDataOfficeRoute
  '/profile/$id': typeof dashboardDashboardProfileIdRoute
  '/attendance': typeof dashboardDashboardAttendanceIndexRoute
  '/loan': typeof dashboardDashboardLoanIndexRoute
  '/performance-review': typeof dashboardDashboardPerformanceReviewIndexRoute
  '/profile': typeof dashboardDashboardProfileIndexRoute
  '/ess/absence/$id': typeof dashboardDashboardEssAbsenceIdRoute
  '/ess/leave/$id': typeof dashboardDashboardEssLeaveIdRoute
  '/hr/employee-edit/$id': typeof dashboardDashboardHrEmployeeEditIdRoute
  '/hr/employee/office': typeof dashboardDashboardHrEmployeeOfficeRoute
  '/hr/employee/shift': typeof dashboardDashboardHrEmployeeShiftRoute
  '/hr/employee/shift-daily': typeof dashboardDashboardHrEmployeeShiftDailyRoute
  '/hr/role/add': typeof dashboardDashboardHrRoleAddRoute
  '/performance-review/$id/competency': typeof dashboardDashboardPerformanceReviewIdCompetencyRoute
  '/performance-review/$id/document-status': typeof dashboardDashboardPerformanceReviewIdDocumentStatusRoute
  '/performance-review/$id/summary': typeof dashboardDashboardPerformanceReviewIdSummaryRoute
  '/ess/absence': typeof dashboardDashboardEssAbsenceIndexRoute
  '/ess/leave': typeof dashboardDashboardEssLeaveIndexRoute
  '/finance/reimbursement': typeof dashboardDashboardFinanceReimbursementIndexRoute
  '/hr/employee': typeof dashboardDashboardHrEmployeeIndexRoute
  '/hr/role': typeof dashboardDashboardHrRoleIndexRoute
  '/performance-review/$id': typeof dashboardDashboardPerformanceReviewIdIndexRoute
  '/finance/reimbursement/$id/employee': typeof dashboardDashboardFinanceReimbursementIdEmployeeRoute
  '/hr/role/edit/$id': typeof dashboardDashboardHrRoleEditIdRoute
  '/finance/reimbursement/$id': typeof dashboardDashboardFinanceReimbursementIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(auth)': typeof authRouteWithChildren
  '/(auth)/_auth': typeof authAuthRouteWithChildren
  '/(dashboard)': typeof dashboardRouteWithChildren
  '/(dashboard)/_dashboard': typeof dashboardDashboardRouteWithChildren
  '/(auth)/_auth/login': typeof authAuthLoginRoute
  '/(dashboard)/_dashboard/attendance': typeof dashboardDashboardAttendanceRouteWithChildren
  '/(dashboard)/_dashboard/attendance-map': typeof dashboardDashboardAttendanceMapRoute
  '/(dashboard)/_dashboard/employee-training': typeof dashboardDashboardEmployeeTrainingRoute
  '/(dashboard)/_dashboard/reimbursement': typeof dashboardDashboardReimbursementRoute
  '/(dashboard)/_dashboard/salary-slip': typeof dashboardDashboardSalarySlipRoute
  '/(dashboard)/_dashboard/approval/absence-type': typeof dashboardDashboardApprovalAbsenceTypeRoute
  '/(dashboard)/_dashboard/approval/leave-type': typeof dashboardDashboardApprovalLeaveTypeRoute
  '/(dashboard)/_dashboard/approval/shift': typeof dashboardDashboardApprovalShiftRoute
  '/(dashboard)/_dashboard/approval/training': typeof dashboardDashboardApprovalTrainingRoute
  '/(dashboard)/_dashboard/attendance/monthly-report': typeof dashboardDashboardAttendanceMonthlyReportRoute
  '/(dashboard)/_dashboard/attendance/waiting-approval': typeof dashboardDashboardAttendanceWaitingApprovalRoute
  '/(dashboard)/_dashboard/ess/overtime': typeof dashboardDashboardEssOvertimeRoute
  '/(dashboard)/_dashboard/finance/payroll-component': typeof dashboardDashboardFinancePayrollComponentRoute
  '/(dashboard)/_dashboard/hr/division': typeof dashboardDashboardHrDivisionRoute
  '/(dashboard)/_dashboard/hr/employee': typeof dashboardDashboardHrEmployeeRouteWithChildren
  '/(dashboard)/_dashboard/hr/position': typeof dashboardDashboardHrPositionRoute
  '/(dashboard)/_dashboard/hr/unit': typeof dashboardDashboardHrUnitRoute
  '/(dashboard)/_dashboard/loan/$id': typeof dashboardDashboardLoanIdRoute
  '/(dashboard)/_dashboard/master-data/employee-add': typeof dashboardDashboardMasterDataEmployeeAddRoute
  '/(dashboard)/_dashboard/master-data/office': typeof dashboardDashboardMasterDataOfficeRoute
  '/(dashboard)/_dashboard/performance-review/$id': typeof dashboardDashboardPerformanceReviewIdRouteWithChildren
  '/(dashboard)/_dashboard/profile/$id': typeof dashboardDashboardProfileIdRoute
  '/(dashboard)/_dashboard/attendance/': typeof dashboardDashboardAttendanceIndexRoute
  '/(dashboard)/_dashboard/loan/': typeof dashboardDashboardLoanIndexRoute
  '/(dashboard)/_dashboard/performance-review/': typeof dashboardDashboardPerformanceReviewIndexRoute
  '/(dashboard)/_dashboard/profile/': typeof dashboardDashboardProfileIndexRoute
  '/(dashboard)/_dashboard/ess/absence/$id': typeof dashboardDashboardEssAbsenceIdRoute
  '/(dashboard)/_dashboard/ess/leave/$id': typeof dashboardDashboardEssLeaveIdRoute
  '/(dashboard)/_dashboard/finance/reimbursement/$id': typeof dashboardDashboardFinanceReimbursementIdRouteWithChildren
  '/(dashboard)/_dashboard/hr/employee-edit/$id': typeof dashboardDashboardHrEmployeeEditIdRoute
  '/(dashboard)/_dashboard/hr/employee/office': typeof dashboardDashboardHrEmployeeOfficeRoute
  '/(dashboard)/_dashboard/hr/employee/shift': typeof dashboardDashboardHrEmployeeShiftRoute
  '/(dashboard)/_dashboard/hr/employee/shift-daily': typeof dashboardDashboardHrEmployeeShiftDailyRoute
  '/(dashboard)/_dashboard/hr/role/add': typeof dashboardDashboardHrRoleAddRoute
  '/(dashboard)/_dashboard/performance-review/$id/competency': typeof dashboardDashboardPerformanceReviewIdCompetencyRoute
  '/(dashboard)/_dashboard/performance-review/$id/document-status': typeof dashboardDashboardPerformanceReviewIdDocumentStatusRoute
  '/(dashboard)/_dashboard/performance-review/$id/summary': typeof dashboardDashboardPerformanceReviewIdSummaryRoute
  '/(dashboard)/_dashboard/ess/absence/': typeof dashboardDashboardEssAbsenceIndexRoute
  '/(dashboard)/_dashboard/ess/leave/': typeof dashboardDashboardEssLeaveIndexRoute
  '/(dashboard)/_dashboard/finance/reimbursement/': typeof dashboardDashboardFinanceReimbursementIndexRoute
  '/(dashboard)/_dashboard/hr/employee/': typeof dashboardDashboardHrEmployeeIndexRoute
  '/(dashboard)/_dashboard/hr/role/': typeof dashboardDashboardHrRoleIndexRoute
  '/(dashboard)/_dashboard/performance-review/$id/': typeof dashboardDashboardPerformanceReviewIdIndexRoute
  '/(dashboard)/_dashboard/finance/reimbursement/$id/employee': typeof dashboardDashboardFinanceReimbursementIdEmployeeRoute
  '/(dashboard)/_dashboard/hr/role/edit/$id': typeof dashboardDashboardHrRoleEditIdRoute
  '/(dashboard)/_dashboard/finance/reimbursement/$id/': typeof dashboardDashboardFinanceReimbursementIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/attendance'
    | '/attendance-map'
    | '/employee-training'
    | '/reimbursement'
    | '/salary-slip'
    | '/approval/absence-type'
    | '/approval/leave-type'
    | '/approval/shift'
    | '/approval/training'
    | '/attendance/monthly-report'
    | '/attendance/waiting-approval'
    | '/ess/overtime'
    | '/finance/payroll-component'
    | '/hr/division'
    | '/hr/employee'
    | '/hr/position'
    | '/hr/unit'
    | '/loan/$id'
    | '/master-data/employee-add'
    | '/master-data/office'
    | '/performance-review/$id'
    | '/profile/$id'
    | '/attendance/'
    | '/loan'
    | '/performance-review'
    | '/profile'
    | '/ess/absence/$id'
    | '/ess/leave/$id'
    | '/finance/reimbursement/$id'
    | '/hr/employee-edit/$id'
    | '/hr/employee/office'
    | '/hr/employee/shift'
    | '/hr/employee/shift-daily'
    | '/hr/role/add'
    | '/performance-review/$id/competency'
    | '/performance-review/$id/document-status'
    | '/performance-review/$id/summary'
    | '/ess/absence'
    | '/ess/leave'
    | '/finance/reimbursement'
    | '/hr/employee/'
    | '/hr/role'
    | '/performance-review/$id/'
    | '/finance/reimbursement/$id/employee'
    | '/hr/role/edit/$id'
    | '/finance/reimbursement/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/attendance-map'
    | '/employee-training'
    | '/reimbursement'
    | '/salary-slip'
    | '/approval/absence-type'
    | '/approval/leave-type'
    | '/approval/shift'
    | '/approval/training'
    | '/attendance/monthly-report'
    | '/attendance/waiting-approval'
    | '/ess/overtime'
    | '/finance/payroll-component'
    | '/hr/division'
    | '/hr/position'
    | '/hr/unit'
    | '/loan/$id'
    | '/master-data/employee-add'
    | '/master-data/office'
    | '/profile/$id'
    | '/attendance'
    | '/loan'
    | '/performance-review'
    | '/profile'
    | '/ess/absence/$id'
    | '/ess/leave/$id'
    | '/hr/employee-edit/$id'
    | '/hr/employee/office'
    | '/hr/employee/shift'
    | '/hr/employee/shift-daily'
    | '/hr/role/add'
    | '/performance-review/$id/competency'
    | '/performance-review/$id/document-status'
    | '/performance-review/$id/summary'
    | '/ess/absence'
    | '/ess/leave'
    | '/finance/reimbursement'
    | '/hr/employee'
    | '/hr/role'
    | '/performance-review/$id'
    | '/finance/reimbursement/$id/employee'
    | '/hr/role/edit/$id'
    | '/finance/reimbursement/$id'
  id:
    | '__root__'
    | '/'
    | '/(auth)'
    | '/(auth)/_auth'
    | '/(dashboard)'
    | '/(dashboard)/_dashboard'
    | '/(auth)/_auth/login'
    | '/(dashboard)/_dashboard/attendance'
    | '/(dashboard)/_dashboard/attendance-map'
    | '/(dashboard)/_dashboard/employee-training'
    | '/(dashboard)/_dashboard/reimbursement'
    | '/(dashboard)/_dashboard/salary-slip'
    | '/(dashboard)/_dashboard/approval/absence-type'
    | '/(dashboard)/_dashboard/approval/leave-type'
    | '/(dashboard)/_dashboard/approval/shift'
    | '/(dashboard)/_dashboard/approval/training'
    | '/(dashboard)/_dashboard/attendance/monthly-report'
    | '/(dashboard)/_dashboard/attendance/waiting-approval'
    | '/(dashboard)/_dashboard/ess/overtime'
    | '/(dashboard)/_dashboard/finance/payroll-component'
    | '/(dashboard)/_dashboard/hr/division'
    | '/(dashboard)/_dashboard/hr/employee'
    | '/(dashboard)/_dashboard/hr/position'
    | '/(dashboard)/_dashboard/hr/unit'
    | '/(dashboard)/_dashboard/loan/$id'
    | '/(dashboard)/_dashboard/master-data/employee-add'
    | '/(dashboard)/_dashboard/master-data/office'
    | '/(dashboard)/_dashboard/performance-review/$id'
    | '/(dashboard)/_dashboard/profile/$id'
    | '/(dashboard)/_dashboard/attendance/'
    | '/(dashboard)/_dashboard/loan/'
    | '/(dashboard)/_dashboard/performance-review/'
    | '/(dashboard)/_dashboard/profile/'
    | '/(dashboard)/_dashboard/ess/absence/$id'
    | '/(dashboard)/_dashboard/ess/leave/$id'
    | '/(dashboard)/_dashboard/finance/reimbursement/$id'
    | '/(dashboard)/_dashboard/hr/employee-edit/$id'
    | '/(dashboard)/_dashboard/hr/employee/office'
    | '/(dashboard)/_dashboard/hr/employee/shift'
    | '/(dashboard)/_dashboard/hr/employee/shift-daily'
    | '/(dashboard)/_dashboard/hr/role/add'
    | '/(dashboard)/_dashboard/performance-review/$id/competency'
    | '/(dashboard)/_dashboard/performance-review/$id/document-status'
    | '/(dashboard)/_dashboard/performance-review/$id/summary'
    | '/(dashboard)/_dashboard/ess/absence/'
    | '/(dashboard)/_dashboard/ess/leave/'
    | '/(dashboard)/_dashboard/finance/reimbursement/'
    | '/(dashboard)/_dashboard/hr/employee/'
    | '/(dashboard)/_dashboard/hr/role/'
    | '/(dashboard)/_dashboard/performance-review/$id/'
    | '/(dashboard)/_dashboard/finance/reimbursement/$id/employee'
    | '/(dashboard)/_dashboard/hr/role/edit/$id'
    | '/(dashboard)/_dashboard/finance/reimbursement/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authRoute: typeof authRouteWithChildren
  dashboardRoute: typeof dashboardRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(dashboard)': {
      id: '/(dashboard)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof dashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)/_dashboard': {
      id: '/(dashboard)/_dashboard'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof dashboardDashboardRouteImport
      parentRoute: typeof dashboardRoute
    }
    '/(auth)/_auth': {
      id: '/(auth)/_auth'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authAuthRouteImport
      parentRoute: typeof authRoute
    }
    '/(dashboard)/_dashboard/salary-slip': {
      id: '/(dashboard)/_dashboard/salary-slip'
      path: '/salary-slip'
      fullPath: '/salary-slip'
      preLoaderRoute: typeof dashboardDashboardSalarySlipRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/reimbursement': {
      id: '/(dashboard)/_dashboard/reimbursement'
      path: '/reimbursement'
      fullPath: '/reimbursement'
      preLoaderRoute: typeof dashboardDashboardReimbursementRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/employee-training': {
      id: '/(dashboard)/_dashboard/employee-training'
      path: '/employee-training'
      fullPath: '/employee-training'
      preLoaderRoute: typeof dashboardDashboardEmployeeTrainingRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/attendance-map': {
      id: '/(dashboard)/_dashboard/attendance-map'
      path: '/attendance-map'
      fullPath: '/attendance-map'
      preLoaderRoute: typeof dashboardDashboardAttendanceMapRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/attendance': {
      id: '/(dashboard)/_dashboard/attendance'
      path: '/attendance'
      fullPath: '/attendance'
      preLoaderRoute: typeof dashboardDashboardAttendanceRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(auth)/_auth/login': {
      id: '/(auth)/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authAuthLoginRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(dashboard)/_dashboard/profile/': {
      id: '/(dashboard)/_dashboard/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof dashboardDashboardProfileIndexRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/performance-review/': {
      id: '/(dashboard)/_dashboard/performance-review/'
      path: '/performance-review'
      fullPath: '/performance-review'
      preLoaderRoute: typeof dashboardDashboardPerformanceReviewIndexRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/loan/': {
      id: '/(dashboard)/_dashboard/loan/'
      path: '/loan'
      fullPath: '/loan'
      preLoaderRoute: typeof dashboardDashboardLoanIndexRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/attendance/': {
      id: '/(dashboard)/_dashboard/attendance/'
      path: '/'
      fullPath: '/attendance/'
      preLoaderRoute: typeof dashboardDashboardAttendanceIndexRouteImport
      parentRoute: typeof dashboardDashboardAttendanceRoute
    }
    '/(dashboard)/_dashboard/profile/$id': {
      id: '/(dashboard)/_dashboard/profile/$id'
      path: '/profile/$id'
      fullPath: '/profile/$id'
      preLoaderRoute: typeof dashboardDashboardProfileIdRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/performance-review/$id': {
      id: '/(dashboard)/_dashboard/performance-review/$id'
      path: '/performance-review/$id'
      fullPath: '/performance-review/$id'
      preLoaderRoute: typeof dashboardDashboardPerformanceReviewIdRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/master-data/office': {
      id: '/(dashboard)/_dashboard/master-data/office'
      path: '/master-data/office'
      fullPath: '/master-data/office'
      preLoaderRoute: typeof dashboardDashboardMasterDataOfficeRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/master-data/employee-add': {
      id: '/(dashboard)/_dashboard/master-data/employee-add'
      path: '/master-data/employee-add'
      fullPath: '/master-data/employee-add'
      preLoaderRoute: typeof dashboardDashboardMasterDataEmployeeAddRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/loan/$id': {
      id: '/(dashboard)/_dashboard/loan/$id'
      path: '/loan/$id'
      fullPath: '/loan/$id'
      preLoaderRoute: typeof dashboardDashboardLoanIdRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/hr/unit': {
      id: '/(dashboard)/_dashboard/hr/unit'
      path: '/hr/unit'
      fullPath: '/hr/unit'
      preLoaderRoute: typeof dashboardDashboardHrUnitRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/hr/position': {
      id: '/(dashboard)/_dashboard/hr/position'
      path: '/hr/position'
      fullPath: '/hr/position'
      preLoaderRoute: typeof dashboardDashboardHrPositionRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/hr/employee': {
      id: '/(dashboard)/_dashboard/hr/employee'
      path: '/hr/employee'
      fullPath: '/hr/employee'
      preLoaderRoute: typeof dashboardDashboardHrEmployeeRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/hr/division': {
      id: '/(dashboard)/_dashboard/hr/division'
      path: '/hr/division'
      fullPath: '/hr/division'
      preLoaderRoute: typeof dashboardDashboardHrDivisionRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/finance/payroll-component': {
      id: '/(dashboard)/_dashboard/finance/payroll-component'
      path: '/finance/payroll-component'
      fullPath: '/finance/payroll-component'
      preLoaderRoute: typeof dashboardDashboardFinancePayrollComponentRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/ess/overtime': {
      id: '/(dashboard)/_dashboard/ess/overtime'
      path: '/ess/overtime'
      fullPath: '/ess/overtime'
      preLoaderRoute: typeof dashboardDashboardEssOvertimeRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/attendance/waiting-approval': {
      id: '/(dashboard)/_dashboard/attendance/waiting-approval'
      path: '/waiting-approval'
      fullPath: '/attendance/waiting-approval'
      preLoaderRoute: typeof dashboardDashboardAttendanceWaitingApprovalRouteImport
      parentRoute: typeof dashboardDashboardAttendanceRoute
    }
    '/(dashboard)/_dashboard/attendance/monthly-report': {
      id: '/(dashboard)/_dashboard/attendance/monthly-report'
      path: '/monthly-report'
      fullPath: '/attendance/monthly-report'
      preLoaderRoute: typeof dashboardDashboardAttendanceMonthlyReportRouteImport
      parentRoute: typeof dashboardDashboardAttendanceRoute
    }
    '/(dashboard)/_dashboard/approval/training': {
      id: '/(dashboard)/_dashboard/approval/training'
      path: '/approval/training'
      fullPath: '/approval/training'
      preLoaderRoute: typeof dashboardDashboardApprovalTrainingRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/approval/shift': {
      id: '/(dashboard)/_dashboard/approval/shift'
      path: '/approval/shift'
      fullPath: '/approval/shift'
      preLoaderRoute: typeof dashboardDashboardApprovalShiftRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/approval/leave-type': {
      id: '/(dashboard)/_dashboard/approval/leave-type'
      path: '/approval/leave-type'
      fullPath: '/approval/leave-type'
      preLoaderRoute: typeof dashboardDashboardApprovalLeaveTypeRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/approval/absence-type': {
      id: '/(dashboard)/_dashboard/approval/absence-type'
      path: '/approval/absence-type'
      fullPath: '/approval/absence-type'
      preLoaderRoute: typeof dashboardDashboardApprovalAbsenceTypeRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/performance-review/$id/': {
      id: '/(dashboard)/_dashboard/performance-review/$id/'
      path: '/'
      fullPath: '/performance-review/$id/'
      preLoaderRoute: typeof dashboardDashboardPerformanceReviewIdIndexRouteImport
      parentRoute: typeof dashboardDashboardPerformanceReviewIdRoute
    }
    '/(dashboard)/_dashboard/hr/role/': {
      id: '/(dashboard)/_dashboard/hr/role/'
      path: '/hr/role'
      fullPath: '/hr/role'
      preLoaderRoute: typeof dashboardDashboardHrRoleIndexRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/hr/employee/': {
      id: '/(dashboard)/_dashboard/hr/employee/'
      path: '/'
      fullPath: '/hr/employee/'
      preLoaderRoute: typeof dashboardDashboardHrEmployeeIndexRouteImport
      parentRoute: typeof dashboardDashboardHrEmployeeRoute
    }
    '/(dashboard)/_dashboard/finance/reimbursement/': {
      id: '/(dashboard)/_dashboard/finance/reimbursement/'
      path: '/finance/reimbursement'
      fullPath: '/finance/reimbursement'
      preLoaderRoute: typeof dashboardDashboardFinanceReimbursementIndexRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/ess/leave/': {
      id: '/(dashboard)/_dashboard/ess/leave/'
      path: '/ess/leave'
      fullPath: '/ess/leave'
      preLoaderRoute: typeof dashboardDashboardEssLeaveIndexRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/ess/absence/': {
      id: '/(dashboard)/_dashboard/ess/absence/'
      path: '/ess/absence'
      fullPath: '/ess/absence'
      preLoaderRoute: typeof dashboardDashboardEssAbsenceIndexRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/performance-review/$id/summary': {
      id: '/(dashboard)/_dashboard/performance-review/$id/summary'
      path: '/summary'
      fullPath: '/performance-review/$id/summary'
      preLoaderRoute: typeof dashboardDashboardPerformanceReviewIdSummaryRouteImport
      parentRoute: typeof dashboardDashboardPerformanceReviewIdRoute
    }
    '/(dashboard)/_dashboard/performance-review/$id/document-status': {
      id: '/(dashboard)/_dashboard/performance-review/$id/document-status'
      path: '/document-status'
      fullPath: '/performance-review/$id/document-status'
      preLoaderRoute: typeof dashboardDashboardPerformanceReviewIdDocumentStatusRouteImport
      parentRoute: typeof dashboardDashboardPerformanceReviewIdRoute
    }
    '/(dashboard)/_dashboard/performance-review/$id/competency': {
      id: '/(dashboard)/_dashboard/performance-review/$id/competency'
      path: '/competency'
      fullPath: '/performance-review/$id/competency'
      preLoaderRoute: typeof dashboardDashboardPerformanceReviewIdCompetencyRouteImport
      parentRoute: typeof dashboardDashboardPerformanceReviewIdRoute
    }
    '/(dashboard)/_dashboard/hr/role/add': {
      id: '/(dashboard)/_dashboard/hr/role/add'
      path: '/hr/role/add'
      fullPath: '/hr/role/add'
      preLoaderRoute: typeof dashboardDashboardHrRoleAddRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/hr/employee/shift-daily': {
      id: '/(dashboard)/_dashboard/hr/employee/shift-daily'
      path: '/shift-daily'
      fullPath: '/hr/employee/shift-daily'
      preLoaderRoute: typeof dashboardDashboardHrEmployeeShiftDailyRouteImport
      parentRoute: typeof dashboardDashboardHrEmployeeRoute
    }
    '/(dashboard)/_dashboard/hr/employee/shift': {
      id: '/(dashboard)/_dashboard/hr/employee/shift'
      path: '/shift'
      fullPath: '/hr/employee/shift'
      preLoaderRoute: typeof dashboardDashboardHrEmployeeShiftRouteImport
      parentRoute: typeof dashboardDashboardHrEmployeeRoute
    }
    '/(dashboard)/_dashboard/hr/employee/office': {
      id: '/(dashboard)/_dashboard/hr/employee/office'
      path: '/office'
      fullPath: '/hr/employee/office'
      preLoaderRoute: typeof dashboardDashboardHrEmployeeOfficeRouteImport
      parentRoute: typeof dashboardDashboardHrEmployeeRoute
    }
    '/(dashboard)/_dashboard/hr/employee-edit/$id': {
      id: '/(dashboard)/_dashboard/hr/employee-edit/$id'
      path: '/hr/employee-edit/$id'
      fullPath: '/hr/employee-edit/$id'
      preLoaderRoute: typeof dashboardDashboardHrEmployeeEditIdRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/finance/reimbursement/$id': {
      id: '/(dashboard)/_dashboard/finance/reimbursement/$id'
      path: '/finance/reimbursement/$id'
      fullPath: '/finance/reimbursement/$id'
      preLoaderRoute: typeof dashboardDashboardFinanceReimbursementIdRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/ess/leave/$id': {
      id: '/(dashboard)/_dashboard/ess/leave/$id'
      path: '/ess/leave/$id'
      fullPath: '/ess/leave/$id'
      preLoaderRoute: typeof dashboardDashboardEssLeaveIdRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/ess/absence/$id': {
      id: '/(dashboard)/_dashboard/ess/absence/$id'
      path: '/ess/absence/$id'
      fullPath: '/ess/absence/$id'
      preLoaderRoute: typeof dashboardDashboardEssAbsenceIdRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/finance/reimbursement/$id/': {
      id: '/(dashboard)/_dashboard/finance/reimbursement/$id/'
      path: '/'
      fullPath: '/finance/reimbursement/$id/'
      preLoaderRoute: typeof dashboardDashboardFinanceReimbursementIdIndexRouteImport
      parentRoute: typeof dashboardDashboardFinanceReimbursementIdRoute
    }
    '/(dashboard)/_dashboard/hr/role/edit/$id': {
      id: '/(dashboard)/_dashboard/hr/role/edit/$id'
      path: '/hr/role/edit/$id'
      fullPath: '/hr/role/edit/$id'
      preLoaderRoute: typeof dashboardDashboardHrRoleEditIdRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(dashboard)/_dashboard/finance/reimbursement/$id/employee': {
      id: '/(dashboard)/_dashboard/finance/reimbursement/$id/employee'
      path: '/employee'
      fullPath: '/finance/reimbursement/$id/employee'
      preLoaderRoute: typeof dashboardDashboardFinanceReimbursementIdEmployeeRouteImport
      parentRoute: typeof dashboardDashboardFinanceReimbursementIdRoute
    }
  }
}

interface authAuthRouteChildren {
  authAuthLoginRoute: typeof authAuthLoginRoute
}

const authAuthRouteChildren: authAuthRouteChildren = {
  authAuthLoginRoute: authAuthLoginRoute,
}

const authAuthRouteWithChildren = authAuthRoute._addFileChildren(
  authAuthRouteChildren,
)

interface authRouteChildren {
  authAuthRoute: typeof authAuthRouteWithChildren
}

const authRouteChildren: authRouteChildren = {
  authAuthRoute: authAuthRouteWithChildren,
}

const authRouteWithChildren = authRoute._addFileChildren(authRouteChildren)

interface dashboardDashboardAttendanceRouteChildren {
  dashboardDashboardAttendanceMonthlyReportRoute: typeof dashboardDashboardAttendanceMonthlyReportRoute
  dashboardDashboardAttendanceWaitingApprovalRoute: typeof dashboardDashboardAttendanceWaitingApprovalRoute
  dashboardDashboardAttendanceIndexRoute: typeof dashboardDashboardAttendanceIndexRoute
}

const dashboardDashboardAttendanceRouteChildren: dashboardDashboardAttendanceRouteChildren =
  {
    dashboardDashboardAttendanceMonthlyReportRoute:
      dashboardDashboardAttendanceMonthlyReportRoute,
    dashboardDashboardAttendanceWaitingApprovalRoute:
      dashboardDashboardAttendanceWaitingApprovalRoute,
    dashboardDashboardAttendanceIndexRoute:
      dashboardDashboardAttendanceIndexRoute,
  }

const dashboardDashboardAttendanceRouteWithChildren =
  dashboardDashboardAttendanceRoute._addFileChildren(
    dashboardDashboardAttendanceRouteChildren,
  )

interface dashboardDashboardHrEmployeeRouteChildren {
  dashboardDashboardHrEmployeeOfficeRoute: typeof dashboardDashboardHrEmployeeOfficeRoute
  dashboardDashboardHrEmployeeShiftRoute: typeof dashboardDashboardHrEmployeeShiftRoute
  dashboardDashboardHrEmployeeShiftDailyRoute: typeof dashboardDashboardHrEmployeeShiftDailyRoute
  dashboardDashboardHrEmployeeIndexRoute: typeof dashboardDashboardHrEmployeeIndexRoute
}

const dashboardDashboardHrEmployeeRouteChildren: dashboardDashboardHrEmployeeRouteChildren =
  {
    dashboardDashboardHrEmployeeOfficeRoute:
      dashboardDashboardHrEmployeeOfficeRoute,
    dashboardDashboardHrEmployeeShiftRoute:
      dashboardDashboardHrEmployeeShiftRoute,
    dashboardDashboardHrEmployeeShiftDailyRoute:
      dashboardDashboardHrEmployeeShiftDailyRoute,
    dashboardDashboardHrEmployeeIndexRoute:
      dashboardDashboardHrEmployeeIndexRoute,
  }

const dashboardDashboardHrEmployeeRouteWithChildren =
  dashboardDashboardHrEmployeeRoute._addFileChildren(
    dashboardDashboardHrEmployeeRouteChildren,
  )

interface dashboardDashboardPerformanceReviewIdRouteChildren {
  dashboardDashboardPerformanceReviewIdCompetencyRoute: typeof dashboardDashboardPerformanceReviewIdCompetencyRoute
  dashboardDashboardPerformanceReviewIdDocumentStatusRoute: typeof dashboardDashboardPerformanceReviewIdDocumentStatusRoute
  dashboardDashboardPerformanceReviewIdSummaryRoute: typeof dashboardDashboardPerformanceReviewIdSummaryRoute
  dashboardDashboardPerformanceReviewIdIndexRoute: typeof dashboardDashboardPerformanceReviewIdIndexRoute
}

const dashboardDashboardPerformanceReviewIdRouteChildren: dashboardDashboardPerformanceReviewIdRouteChildren =
  {
    dashboardDashboardPerformanceReviewIdCompetencyRoute:
      dashboardDashboardPerformanceReviewIdCompetencyRoute,
    dashboardDashboardPerformanceReviewIdDocumentStatusRoute:
      dashboardDashboardPerformanceReviewIdDocumentStatusRoute,
    dashboardDashboardPerformanceReviewIdSummaryRoute:
      dashboardDashboardPerformanceReviewIdSummaryRoute,
    dashboardDashboardPerformanceReviewIdIndexRoute:
      dashboardDashboardPerformanceReviewIdIndexRoute,
  }

const dashboardDashboardPerformanceReviewIdRouteWithChildren =
  dashboardDashboardPerformanceReviewIdRoute._addFileChildren(
    dashboardDashboardPerformanceReviewIdRouteChildren,
  )

interface dashboardDashboardFinanceReimbursementIdRouteChildren {
  dashboardDashboardFinanceReimbursementIdEmployeeRoute: typeof dashboardDashboardFinanceReimbursementIdEmployeeRoute
  dashboardDashboardFinanceReimbursementIdIndexRoute: typeof dashboardDashboardFinanceReimbursementIdIndexRoute
}

const dashboardDashboardFinanceReimbursementIdRouteChildren: dashboardDashboardFinanceReimbursementIdRouteChildren =
  {
    dashboardDashboardFinanceReimbursementIdEmployeeRoute:
      dashboardDashboardFinanceReimbursementIdEmployeeRoute,
    dashboardDashboardFinanceReimbursementIdIndexRoute:
      dashboardDashboardFinanceReimbursementIdIndexRoute,
  }

const dashboardDashboardFinanceReimbursementIdRouteWithChildren =
  dashboardDashboardFinanceReimbursementIdRoute._addFileChildren(
    dashboardDashboardFinanceReimbursementIdRouteChildren,
  )

interface dashboardDashboardRouteChildren {
  dashboardDashboardAttendanceRoute: typeof dashboardDashboardAttendanceRouteWithChildren
  dashboardDashboardAttendanceMapRoute: typeof dashboardDashboardAttendanceMapRoute
  dashboardDashboardEmployeeTrainingRoute: typeof dashboardDashboardEmployeeTrainingRoute
  dashboardDashboardReimbursementRoute: typeof dashboardDashboardReimbursementRoute
  dashboardDashboardSalarySlipRoute: typeof dashboardDashboardSalarySlipRoute
  dashboardDashboardApprovalAbsenceTypeRoute: typeof dashboardDashboardApprovalAbsenceTypeRoute
  dashboardDashboardApprovalLeaveTypeRoute: typeof dashboardDashboardApprovalLeaveTypeRoute
  dashboardDashboardApprovalShiftRoute: typeof dashboardDashboardApprovalShiftRoute
  dashboardDashboardApprovalTrainingRoute: typeof dashboardDashboardApprovalTrainingRoute
  dashboardDashboardEssOvertimeRoute: typeof dashboardDashboardEssOvertimeRoute
  dashboardDashboardFinancePayrollComponentRoute: typeof dashboardDashboardFinancePayrollComponentRoute
  dashboardDashboardHrDivisionRoute: typeof dashboardDashboardHrDivisionRoute
  dashboardDashboardHrEmployeeRoute: typeof dashboardDashboardHrEmployeeRouteWithChildren
  dashboardDashboardHrPositionRoute: typeof dashboardDashboardHrPositionRoute
  dashboardDashboardHrUnitRoute: typeof dashboardDashboardHrUnitRoute
  dashboardDashboardLoanIdRoute: typeof dashboardDashboardLoanIdRoute
  dashboardDashboardMasterDataEmployeeAddRoute: typeof dashboardDashboardMasterDataEmployeeAddRoute
  dashboardDashboardMasterDataOfficeRoute: typeof dashboardDashboardMasterDataOfficeRoute
  dashboardDashboardPerformanceReviewIdRoute: typeof dashboardDashboardPerformanceReviewIdRouteWithChildren
  dashboardDashboardProfileIdRoute: typeof dashboardDashboardProfileIdRoute
  dashboardDashboardLoanIndexRoute: typeof dashboardDashboardLoanIndexRoute
  dashboardDashboardPerformanceReviewIndexRoute: typeof dashboardDashboardPerformanceReviewIndexRoute
  dashboardDashboardProfileIndexRoute: typeof dashboardDashboardProfileIndexRoute
  dashboardDashboardEssAbsenceIdRoute: typeof dashboardDashboardEssAbsenceIdRoute
  dashboardDashboardEssLeaveIdRoute: typeof dashboardDashboardEssLeaveIdRoute
  dashboardDashboardFinanceReimbursementIdRoute: typeof dashboardDashboardFinanceReimbursementIdRouteWithChildren
  dashboardDashboardHrEmployeeEditIdRoute: typeof dashboardDashboardHrEmployeeEditIdRoute
  dashboardDashboardHrRoleAddRoute: typeof dashboardDashboardHrRoleAddRoute
  dashboardDashboardEssAbsenceIndexRoute: typeof dashboardDashboardEssAbsenceIndexRoute
  dashboardDashboardEssLeaveIndexRoute: typeof dashboardDashboardEssLeaveIndexRoute
  dashboardDashboardFinanceReimbursementIndexRoute: typeof dashboardDashboardFinanceReimbursementIndexRoute
  dashboardDashboardHrRoleIndexRoute: typeof dashboardDashboardHrRoleIndexRoute
  dashboardDashboardHrRoleEditIdRoute: typeof dashboardDashboardHrRoleEditIdRoute
}

const dashboardDashboardRouteChildren: dashboardDashboardRouteChildren = {
  dashboardDashboardAttendanceRoute:
    dashboardDashboardAttendanceRouteWithChildren,
  dashboardDashboardAttendanceMapRoute: dashboardDashboardAttendanceMapRoute,
  dashboardDashboardEmployeeTrainingRoute:
    dashboardDashboardEmployeeTrainingRoute,
  dashboardDashboardReimbursementRoute: dashboardDashboardReimbursementRoute,
  dashboardDashboardSalarySlipRoute: dashboardDashboardSalarySlipRoute,
  dashboardDashboardApprovalAbsenceTypeRoute:
    dashboardDashboardApprovalAbsenceTypeRoute,
  dashboardDashboardApprovalLeaveTypeRoute:
    dashboardDashboardApprovalLeaveTypeRoute,
  dashboardDashboardApprovalShiftRoute: dashboardDashboardApprovalShiftRoute,
  dashboardDashboardApprovalTrainingRoute:
    dashboardDashboardApprovalTrainingRoute,
  dashboardDashboardEssOvertimeRoute: dashboardDashboardEssOvertimeRoute,
  dashboardDashboardFinancePayrollComponentRoute:
    dashboardDashboardFinancePayrollComponentRoute,
  dashboardDashboardHrDivisionRoute: dashboardDashboardHrDivisionRoute,
  dashboardDashboardHrEmployeeRoute:
    dashboardDashboardHrEmployeeRouteWithChildren,
  dashboardDashboardHrPositionRoute: dashboardDashboardHrPositionRoute,
  dashboardDashboardHrUnitRoute: dashboardDashboardHrUnitRoute,
  dashboardDashboardLoanIdRoute: dashboardDashboardLoanIdRoute,
  dashboardDashboardMasterDataEmployeeAddRoute:
    dashboardDashboardMasterDataEmployeeAddRoute,
  dashboardDashboardMasterDataOfficeRoute:
    dashboardDashboardMasterDataOfficeRoute,
  dashboardDashboardPerformanceReviewIdRoute:
    dashboardDashboardPerformanceReviewIdRouteWithChildren,
  dashboardDashboardProfileIdRoute: dashboardDashboardProfileIdRoute,
  dashboardDashboardLoanIndexRoute: dashboardDashboardLoanIndexRoute,
  dashboardDashboardPerformanceReviewIndexRoute:
    dashboardDashboardPerformanceReviewIndexRoute,
  dashboardDashboardProfileIndexRoute: dashboardDashboardProfileIndexRoute,
  dashboardDashboardEssAbsenceIdRoute: dashboardDashboardEssAbsenceIdRoute,
  dashboardDashboardEssLeaveIdRoute: dashboardDashboardEssLeaveIdRoute,
  dashboardDashboardFinanceReimbursementIdRoute:
    dashboardDashboardFinanceReimbursementIdRouteWithChildren,
  dashboardDashboardHrEmployeeEditIdRoute:
    dashboardDashboardHrEmployeeEditIdRoute,
  dashboardDashboardHrRoleAddRoute: dashboardDashboardHrRoleAddRoute,
  dashboardDashboardEssAbsenceIndexRoute:
    dashboardDashboardEssAbsenceIndexRoute,
  dashboardDashboardEssLeaveIndexRoute: dashboardDashboardEssLeaveIndexRoute,
  dashboardDashboardFinanceReimbursementIndexRoute:
    dashboardDashboardFinanceReimbursementIndexRoute,
  dashboardDashboardHrRoleIndexRoute: dashboardDashboardHrRoleIndexRoute,
  dashboardDashboardHrRoleEditIdRoute: dashboardDashboardHrRoleEditIdRoute,
}

const dashboardDashboardRouteWithChildren =
  dashboardDashboardRoute._addFileChildren(dashboardDashboardRouteChildren)

interface dashboardRouteChildren {
  dashboardDashboardRoute: typeof dashboardDashboardRouteWithChildren
}

const dashboardRouteChildren: dashboardRouteChildren = {
  dashboardDashboardRoute: dashboardDashboardRouteWithChildren,
}

const dashboardRouteWithChildren = dashboardRoute._addFileChildren(
  dashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authRoute: authRouteWithChildren,
  dashboardRoute: dashboardRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
